// LoginSelection.js
import React, { useState } from 'react';
import STLEmployeeLogin from './STLEmployeeLogin';
import VendorLogin from './VendorLogin';
import './Login.css'; // reuse same styles

export default function LoginSelection({ onShowRegister, onShowForgot }) {
  const [selected, setSelected] = useState(null); // 'stl' or 'vendor'

  if (selected === 'stl') {
    // Pass setSelected down so the Back button can return here
    return <STLEmployeeLogin onShowRegister={onShowRegister} setSelected={setSelected} />;
  }

  if (selected === 'vendor') {
    return (
      <VendorLogin
        onShowRegister={onShowRegister}
        onShowForgot={onShowForgot}
        setSelected={setSelected}
      />
    );
  }

  return (
    <div className="login-container">
      <div className="logos-container">
        <img draggable={false}
          src={process.env.PUBLIC_URL + '/Main.png'}
          alt="Main Logo"
          className="logo"
        />
        <img draggable={false}
          src={process.env.PUBLIC_URL + '/Invenia.png'}
          alt="Invenia Logo"
          className="logo logo-second"
        />
        <img draggable={false}
          src={process.env.PUBLIC_URL + '/STL_Logo.png'}
          alt="STL Logo"
          className="logo logo-third"  // ⭐ Add this line
        />
      </div>

      <div className="auth-box">
        <h2 className="page-title">Select Login Type</h2>

        <button onClick={() => setSelected('stl')} className="login-type-btn">
          STL Employee
        </button>

        <button onClick={() => setSelected('vendor')} className="login-type-btn">
          Vendor
        </button>
      
        {/* <p>
          Don’t have an account?{' '}
          <button className="link-btn" onClick={onShowRegister}>
            Register
          </button>
        </p> */}
      </div>

      <div style={{ position: 'fixed', bottom: 0, left: 0, width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '10px 0', zIndex: 1000 }}>
        <span style={{ fontWeight: '600', color: '#fff', marginRight: '10px' }}>Powered by</span>
        <img draggable={false} src="/Main.png" alt="STL-DIGITAL" style={{ height: '30px' }} />
      </div>
    </div>
  );
}



